/**
 * List of redux-forms in use in the UI
 * We keep this as an exported list just in case we need to get the values from a redux-form from somewhere else
 */

export const LIBRARY_PROPERTIES = "library-properties";
export const SHARE_LIBRARY = "share-library";
export const ACTION_MODAL_FORM = "action_modal_form";
export const BULK_ACTION_MODAL_FORM = "bulk_action_modal_form";
export const CREATE_SOCIAL_CONCEPT = "create-social-concept";
export const EDIT_SOCIAL_CREATIVE = "edit-social-creative";
export const EDIT_SOCIAL_CONCEPT = "edit-social-concept";
export const ADD_TO_SOCIAL_CONCEPT = "add-to-social-concept";
export const DUPLICATE_VERSION_FORM ="duplicate-version-form";
export const VERSION_SAVE_AS_FORM = "version-save-as";
export const VERSION_RENAME_FORM = "version-rename";
export const EDIT_VERSION_BLADE_FORM = "edit-version-blade-form";
export const CREATE_NATIVE_AD_FORM = "create-native-ad-form";
export const GENERATE_VERSIONS = "generate-versions";
export const CONCEPT_NAME = "open-concept";
export const CREATE_BLANK_IMPOSIUM_FORM = "create-blank-imposium-form";
export const DUPLICATE_DTREE = "duplicate-dtree";
export const ADD_ADSTUDIO_TO_CONCEPT_FORM = "add-adstudio-to-concept-form";
export const ADD_CREATIVE_TAGS_TO_CONCEPT_FORM = "add-creative-tags-to-concept-form";
export const SOCIAL_WIZARD = "social-wizard";
export const LABEL_MANAGEMENT = "label-management";
// Form for inline-preview version of Social Version Editor (see utils/Flags.js)
export const EDIT_SOCIAL_VERSION_2 = "editSocialVersion";
